import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { FormMessageModule } from '../form-message/form-message.module';
import { LoaderButtonModule } from '../loader-button/loader-button.module';
import { RouterModule } from '@angular/router';
import { HistoryItemsModule } from '../history-items/history-items.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { ViewingViewModule } from '../viewing-view/viewing-view.module';
import { FilterCardModule } from '../filter-card/filter-card.module';
import { ContentNotificationModule } from '../content-notification/content-notification.module';
import { FinancialItemViewModule } from '../financial-item-view/financial-item-view.module';
import { DateTimePickerModule } from '../date-time-picker/date-time-picker.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SettlementAddModule } from '../settlement-add/settlement-add.module';
import { LoadingIndicatorModule } from '../loading-indicator/loading-indicator.module';
import { FileLinkModule } from '../file-link/file-link.module';
import { OwnerSettlementSummaryComponent } from './owner-settlement-summary.component';
import { OwnerSettlementFinancialItemSummaryComponent } from './components/owner-settlement-financial-item-summary/owner-settlement-financial-item-summary.component';
import {FileUploaderModule} from "../file-uploader/file-uploader.module";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        PipesModule,
        ViewingViewModule,
        FormMessageModule,
        LoaderButtonModule,
        LoadingIndicatorModule,
        HistoryItemsModule,
        SvgIconModule,
        FilterCardModule,
        ContentNotificationModule,
        PipesModule,
        FinancialItemViewModule,
        DateTimePickerModule,
        ReactiveFormsModule,
        SettlementAddModule,
        FileLinkModule,
        FileUploaderModule

    ],
    declarations: [
        OwnerSettlementFinancialItemSummaryComponent,
        OwnerSettlementSummaryComponent
    ],
    exports: [
        OwnerSettlementSummaryComponent
    ]
})

export class OwnerSettlementSummaryModule {
}
